export const config = {
  production: {
    apiKey: "AIzaSyCBulj8EZhgjzaW_RZ7nkraY9JvKcoGlRw",
    authDomain: 'bigadvice-testadmin.firebaseapp.com',
    databaseURL: "https://big-advice.firebaseio.com",
    projectId: "big-advice",
    storageBucket: "big-advice.appspot.com",
    messagingSenderId: "150409001497"
  },
  development: {
    // apiKey: "AIzaSyD940A-zvTWg29dXG9YV7u7xzrUjMFxf_M",
    // authDomain: 'development-admin.firebaseapp.com',
    // databaseURL: "https://bigadvice-development.firebaseio.com",
    // projectId: "development-admin",
    // storageBucket: "bigadvice-development.appspot.com",
    // messagingSenderId: "939444140358"

    apiKey: "AIzaSyALBsdB9MifbPUQ7xpggk5dMZJs8DgzyXQ",
    authDomain: "bigadvice-development.firebaseapp.com",
    databaseURL: "https://bigadvice-development.firebaseio.com",
    projectId: "bigadvice-development",
    storageBucket: "bigadvice-development.appspot.com",
    messagingSenderId: "939444140358",
    appId: "1:939444140358:web:60d11e167d86561dbb4d47"
  }
};




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/environments/firebase.config.ts